import { LockType, PartnerLockType } from 'types/PartnerLockTypes';

export const hasLockType = (locks: PartnerLockType[] | undefined, type: LockType): boolean => {
  return (locks ?? []).some((lock) => lock?.lockType === type);
};

export const hasNoLocks = (locks: PartnerLockType[] | undefined): boolean => (locks ?? []).length === 0;
